// Your routes — and the navigation binding's, which is the part worth knowing.
//
// THIS FILE IS REPLACED when the navigation shell is re-applied. `bottom-tabs`,
// `stack` and `sidebar` produce different routers, so the binding owns it and
// `appfactory spec apply` rewrites it with `overwrite: true`.
//
// It used to claim the opposite — "the factory never replaces it" — which was
// wrong and expensive: an apply silently took a TABS array full of hand-picked
// labels and icons with it, under a message saying four files were written.
// The apply now says loudly when it REPLACES rather than creates.
//
// So: edit it freely, and commit before running `spec apply`. Everything below
// is yours until the shell itself changes.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';

import StackShell from './pages/StackShell.vue';
import { PRODUCT_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens. main.js pushes this. The machine, obviously. */
export const HOME = HOME_ROUTE;

// The app's destinations, in order. A stack shell renders no chrome from this
// list — there is no bar and no menu to put it in — so it exists for two
// reasons: it is the one place that says what the top-level screens ARE, and it
// is what a `bottom-tabs` or `sidebar` shell will read if this app is
// re-resolved onto one.
//
// `icon` is an IMPORTED ionicon, not a name. `<ion-icon name="home">` fetches
// its SVG from a CDN at runtime, which the app's content-security-policy blocks
// and an offline app could not reach anyway.
import { printOutline, fileTrayFullOutline } from 'ionicons/icons';

// A stack shell renders none of this — the MACHINE is the navigation, and its
// own parts are the controls: the paper tray starts a fax, the output tray
// opens the outbox, SETUP opens settings. This list exists so that re-resolving
// onto `bottom-tabs` or `sidebar` later has something to read.
export const DESTINATIONS = [
  { name: 'machine', label: 'Machine', path: '/tabs/machine', icon: printOutline },
  { name: 'outbox', label: 'Outbox', path: '/tabs/outbox', icon: fileTrayFullOutline },
];

/** The name the tab and sidebar shells read. Kept so switching shell is a
 *  one-file change rather than a rename across the app. */
export const TABS = DESTINATIONS;

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    { path: '/', redirect: HOME },
    {
      // The shell owns the outlet, so every screen below it is a push with a
      // real transition and a working back button. Children rather than
      // top-level routes: a flat list would replace the shell on every
      // navigation, which is a stack that resets itself.
      path: '/tabs/',
      component: StackShell,
      children: [
        { path: '', redirect: HOME },
        ...PRODUCT_ROUTES.map((r) => ({
          path: r.path.replace(/^\/tabs\//, ''),
          name: r.id,
          component: r.component,
          props: true,
        })),
      ],
    },

    // A LINK THAT MISSES STILL HAS TO LAND SOMEWHERE. Without this, a path the
    // table does not know renders the outlet EMPTY — not a not-found screen, a
    // blank page with a warning in a console nobody is reading. The machine is
    // the honest answer to a link that has gone stale.
    { path: '/:pathMatch(.*)*', redirect: HOME },
  ],
});
